<script>
import DraggableList from './form-components/DraggableList.vue'
import simplebar from "simplebar-vue";
import Label from './form-components/Label.vue';
import LocationFilter from './partials/LocationFilter.vue';
import LabelFilter from './partials/LabelFilter.vue';
import RELabelFilter from './partials/RELabelFilter.vue';
import OnlineLabelFilter from './partials/OnlineLabelFilter.vue';
import GroupFilter from './partials/GroupFilter.vue';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true
    },
    selectedItem: {
      type: Object,
      required: true
    },
    prevSelectedItem: {
      type: String,
      required: true
    },
    setSelectedItems: {
      type: Function,
      required: false
    },
    topbarControls: {
      type: Object,
      required: false
    }
  },
  components: {
    DraggableList,
    simplebar, Label,
    LocationFilter, GroupFilter, LabelFilter, RELabelFilter, OnlineLabelFilter
  },
  data(){
    return {
      value: null,
      subgroup: null,
      prevTotalListDataItems: this.listData.length,
      filterValue: null,
      // filteredList: []
    }
  },
  computed: {
    totalListDataItems() {
      return this.listData.length;
    },
    totalItems() {
      return this.filteredList.length;
    },
    totalActiveItems() {
      return this.filteredList.filter((x => x.active == true)).length;
    },
    filteredList() {
      let list = this.listData.filter(x => x.additionalProp1 && x.additionalProp1[this.item.filterOn] && x.additionalProp1[this.item.filterOn] == this.value);
      if(this.subgroup && list.length) {
        list = list.filter(x => x.additionalProp1 && x.additionalProp1.subgroup == this.subgroup)
      }
      if(list.length) {
        if(!list.filter(x => x.id == this.selectedItem.id).length) {
          this.setSelectedItems(list[0]);
        }
      } else {
        this.setSelectedItems(new Object);
      }
      return list;
    }
  },
  watch: {
    totalListDataItems: {
      handler(val) {
        if(this.prevTotalListDataItems != val && this.prevTotalListDataItems < val) {
          const new_member = this.listData[this.listData.length - 1]
          this.filterValue = new_member.group
          this.prevTotalListDataItems = val
        }
      },
      deep: true
    },
    // topbarControls: {
    //   handler(val) {
    //     if(val.title == 'Team') {
    //       if(val.selectedItem && Object.keys(val.selectedItem).length) this.multiSelectUpdated()
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    // multiSelectUpdated() {
    //   let list = this.listData.filter(x => x.additionalProp1 && x.additionalProp1[this.item.filterOn] && x.additionalProp1[this.item.filterOn] == this.value);

    //   if(this.subgroup && list.length) {
    //     list = list.filter(x => x.additionalProp1 && x.additionalProp1.subgroup == this.subgroup)
    //   }
    //   if(list.length) {
    //     if(!list.filter(x => x.id == this.selectedItem.id).length) {
    //       this.setSelectedItems(list[0]);
    //     }
    //   } else {
    //     this.setSelectedItems(new Object);
    //   }
    //   this.filteredList = list;
    // },
    updateValue(val) {
      this.value = val;
      // this.multiSelectUpdated()
    },
    updateSubgroupValue(val) {
      this.subgroup = val;
    }
  },
  mounted() {
    // this.multiSelectUpdated()
  }
};
</script>
<template>
  <div v-if="listData.length">
    <simplebar class="simplebar-custom"
    id="scrollElement"
    data-simplebar-auto-hide="false"
  >
    <LocationFilter v-if="item.filter == 'locations'" :updateValue="updateValue"/>
    <LabelFilter v-if="item.filter == 'labels'" :updateValue="updateValue"/>
    <RELabelFilter v-if="item.filter == 'reLabels'" :updateValue="updateValue"/>
    <OnlineLabelFilter v-if="item.filter == 'onlineLabels'" :updateValue="updateValue"/>
    <GroupFilter v-if="item.filter == 'groups'" :updateValue="updateValue" :updateSubgroupValue="updateSubgroupValue"
    :filterValue="filterValue" :item="item"/>
    <Label v-if="!item.empty" :item="item" :total_items="totalItems" :total_active_items="totalActiveItems"/>
    <DraggableList v-if="item.draggable" :variant="item.variant" :list="filteredList" :selectedItem="selectedItem"
    :setSelectedItems="setSelectedItems" :prevSelectedItem="prevSelectedItem" :topbarControls="topbarControls"
    />  
    </simplebar>
  </div>
  <div v-else></div>
</template>


<style scoped>
 .simplebar-custom {
   min-height: 50vh;
   max-height: calc(100vh - 200px);
   padding-right: 2em;
 }
</style>